import { Badge } from "orcs-design-system";
import React from "react";
import PropTypes from "prop-types";

import GroupPropType from "src/custom-prop-types/group";
import {
  GroupTypePropType,
  GroupTypesPropType,
} from "src/custom-prop-types/groupTypes";
import { getGroupTypeBadgeVariant } from "src/util/group";
import { getGroupType } from "src/util/groupType";
import * as searchUtil from "src/util/search";

const GroupTypeInnerBadge = ({ groupType, selectedString, style }) => (
  <Badge
    data-testid="cp-teamlist-row-badge"
    variant={getGroupTypeBadgeVariant(groupType)}
    style={{
      ...groupType.style,
      ...style,
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }}
    display="block"
  >
    {searchUtil.highlightSelectedString(groupType.name, selectedString)}
  </Badge>
);

GroupTypeInnerBadge.propTypes = {
  groupType: GroupTypePropType.isRequired,
  selectedString: PropTypes.string,
  style: PropTypes.object,
};

const GroupTypeBadge = ({ group, groupTypes, selectedString, style }) => {
  if (!group.type) {
    return null;
  }

  const groupType = getGroupType(group, groupTypes);
  return (
    <GroupTypeInnerBadge
      groupType={groupType}
      selectedString={selectedString}
      style={style}
    />
  );
};

GroupTypeBadge.propTypes = {
  group: GroupPropType,
  groupTypes: GroupTypesPropType,
  selectedString: PropTypes.string,
  style: PropTypes.object,
};

export default GroupTypeBadge;
